export default __webpack_public_path__ + "static/media/ContractFlooring.caed9c29.png";